import {atomWithStorage} from 'jotai/utils';

import {JiraStatusFilterState} from './jiraStatusFilter';

/** Per-status visibility overrides. Unset keys use {@link JIRA_STATUS_FILTER_DEFAULTS}. */
export const jiraStatusFilterAtom = atomWithStorage<JiraStatusFilterState>(
  'dashboard:jiraStatusFilter:v1',
  {}
);
